import type { ReactNode } from 'react'
import styles from './SettingsRow.module.css'

type Props = {
	icon: ReactNode
	label: string
	value: ReactNode
	action?: ReactNode
	hint?: ReactNode
}

// A labelled row with an icon, a value and an optional trailing control —
// the shape Settings is built from, and the one <InviteCode> already had.
// Any <button> dropped into `action` picks up the row's button styling, so
// callers pass markup, not classes.
export const SettingsRow = ({ icon, label, value, action, hint }: Props) => (
	<div className={styles.wrap}>
		<div className={styles.row}>
			<span className={styles.icon} aria-hidden>
				{icon}
			</span>
			<div className={styles.text}>
				<span className={styles.label}>{label}</span>
				<span className={styles.value}>{value}</span>
			</div>
			{action ? <div className={styles.action}>{action}</div> : null}
		</div>
		{hint ? <p className={styles.hint}>{hint}</p> : null}
	</div>
)
